<template>

  <form @submit.prevent="vChangePassword" class="change-password-form">

    <CustomModal 
    :type="modal_type"
    :open="modal_open"
    @close-modal="modal_open = false">
      <template slot="modal_content">
        <p class="notification-text">{{message}}</p>
      </template>
    </CustomModal>

    <div class="grid-row">
      <div class="c-12">
        <div class="form-field">
          <label>{{$_('current_password')}}</label>
          <input type="password" v-model="old_password" />
        </div>
        <div class="form-field">
          <label>{{$_('new_password')}}</label>
          <input type="password" v-model="new_password" />
        </div>
        <div class="form-field">
          <label>{{$_('new_password_confirm')}}</label>
          <input type="password" v-model="confirm_password" />
        </div>
        <div class="form-field">
          <input type="submit" class="btn" :value="$_('validate').toUpperCase()" />
        </div>
      </div>
    </div>
    <div class="grid-row">
      <div class="c-12">
        <p>{{message}}</p>
      </div>
    </div>
  </form>
</template>

<script>

import userService from '@/modules/utilisateur/services/userService';
import CustomModal from '@/common/components/widget/Modal/CustomModal';

export default {
  name: "PasswordChange",
  data() {
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
      message: '',
      modal_type: 'default',
      modal_open: false,
    }
  },
  components: {
    CustomModal
  },
  methods: {
    vChangePassword() {

      if(this.new_password.length < 6) {
        this.modal_type = 'error';
        this.message = this.$_('password_length_error');
        this.modal_open = true;
        return false;
      }

      if(this.new_password === this.confirm_password) {

        userService.getUserPassword()
        .then(res => {
         
          userService.setNewPassword({
            old_password: this.old_password,
            old_hash_password: res.data.PMDP,
            piduser: res.data.PID,
            new_password: this.new_password
          })
          .then(res => {
            if(res.data !== undefined && res.data.POK === 0) {
              this.modal_type = 'error';
              this.message = this.$_('reinit_password_error');
            } else {
              this.modal_type = 'success';
              this.message = this.$_('reinit_password_success_account');
            }
            this.modal_open = true;
          })
        });

      } else {
        this.modal_type = 'error';
        this.message = this.$_('password_not_match');
        this.modal_open = true;
      }
    }
  }
};
</script>

<style scoped>
.change-password-form {
  max-width: 500px;
}
</style>